import { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';
import { createProduct, getProducts, getCatalogCategories, getVarieties, getSpecificities } from 'interfaces/products';
import ProductTypeChoice from './components/ProductTypeChoice';
import BrutProductForm from './components/brutProductForm';
import TransformedProductForm from './components/transformedProductForm';
import AssembledProductForm from './components/assembledProductForm';
import { getSuppliers, addProductToSupplier } from 'interfaces/supplier';
import { toast } from 'react-toastify';

const CreateProduct = () => {
    const navigate = useNavigate();
    const [state, setState] = useState(0);
    const [productType, setProductType] = useState<string>(null);
    const [suppliers, setSuppliers] = useState<any[]>([]);
    const [allProducts, setAllProducts] = useState<any[]>([]);
    const [catalogCategories, setCatalogCategories] = useState<string[]>([]);
    const [varieties, setVarieties] = useState<string[]>([]);
    const [specificities, setSpecificities] = useState<string[]>([]);
    const [newProduct, setNewProduct] = useState<any>({
        name: '',
        category: '',
        hiddenFromShop: true,
        origin: '',
        unity: 'Kg',
        quantity: 0,
        daysOfConservation: 0,
        subProducts: [],
        ref: 'TL-00001',
        price: 0,
        alert: 0,
        dlcAlert: 0,
        brutWeight: 0,
        netWeight: 0,
        suppliers: [],
        vatPurchase: 0,
        ean: '',
        noDlc: false,
        hideWhenOutOfStock: false,
        replacementProducts: [],
        cotisationInterfel: false,
        cotisationInterfelPercentage: '',
    });

    const handleProductChange = (attr: string, value: string) => {
        const newProd: any = newProduct;
        newProd[attr] = value;
        if (attr === 'name') {
            const words = value.split(' ');
            let ref = '';
            let refPrefixSize = 0;
            words.forEach((word: string) => {
                if (word.length > 0 && refPrefixSize < 2) {
                    ref += word[0];
                    refPrefixSize++;
                }
            });
            newProd['ref'] = (ref ? ref.toUpperCase() : 'TL') + '-00001';
        }
        setNewProduct((prevProduct: any) => ({ ...prevProduct, ...newProd }));
    };

    const handleProductCreation = async (handleComposants: boolean) => {
        const newProd: any = newProduct;
        newProd['ingredients'] = [];

        // Clean subproduct
        newProd.subProducts = newProd.subProducts.map((subProduct: any) => {
            return {
                quantity: subProduct.quantity,
                id: subProduct.productId,
            };
        });
        newProd.type = productType;

        const res = await createProduct(newProduct);
        if (res) {
            if (Array.isArray(newProduct.suppliers) && newProduct.suppliers.length > 0) {
                try {
                    await Promise.all(
                        newProduct.suppliers.map((sid: string) =>
                            addProductToSupplier(sid, res._id),
                        ),
                    );
                } catch (e) {
                    console.error('Erreur association fournisseurs', e);
                    toast.warn('Produit créé mais association fournisseurs partielle.');
                }
            }
            navigate(
                handleComposants
                    ? `/handle-comp/${res._id}?o=create`
                    : '/stock/stock-list',
            );
        }
    };

    useEffect(() => {
        if (localStorage.getItem('token') === null) {
            navigate('/login');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        (async () => {
            try {
       const res: any = await getSuppliers();
       const list = Array.isArray(res?.data) ? res.data : (Array.isArray(res) ? res : []);
       setSuppliers(list);
       
       const productsRes: any = await getProducts(1, 50);
       let products: any[] = [];
       if (productsRes) {
          if (Array.isArray(productsRes)) products = productsRes;
          else if (productsRes.data && Array.isArray(productsRes.data)) products = productsRes.data;
          else if (productsRes.meta && productsRes.data) products = productsRes.data;
       }
       setAllProducts(products);

       const categories = await getCatalogCategories();
       setCatalogCategories(categories);

       const varietiesList = await getVarieties();
       setVarieties(varietiesList);

       const specificitiesList = await getSpecificities();
       setSpecificities(specificitiesList);
     } catch (e) {
       console.error('Erreur chargement fournisseurs', e);
     }
   })();
    }, []);

    return (
        <div className="mt-1 grid grid-cols-12">
            <div className={`col-span-12`}>
                {productType ? (
                    <div
                        className="mt-4 sm:mt-0 flex items-center justify-start cursor-pointer"
                        onClick={() => window.location.reload()}
                    >
                        <svg
                            className="w-5 h-5 mr-2"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                strokeWidth="2"
                                d="M15 19l-7-7 7-7"
                            />
                        </svg>
                        <p className="text-xs">Changer le type de produit</p>
                    </div>
                ) : (
                    <ProductTypeChoice
                        productType={productType}
                        setProductType={setProductType}
                    />
                )}

                {productType === 'brut' && (
                    <BrutProductForm
                        newProduct={newProduct}
                        handleProductChange={handleProductChange}
                        state={state}
                        setState={setState}
                        suppliers={suppliers}
                        allProducts={allProducts}
                        catalogCategories={catalogCategories}
                        setCatalogCategories={setCatalogCategories}
                        varieties={varieties}
                        setVarieties={setVarieties}
                        specificities={specificities}
                        setSpecificities={setSpecificities}
                    />
                )}

                {productType === 'transformed' && (
                    <TransformedProductForm
                        product={newProduct}
                        handleProductChange={handleProductChange}
                        state={state}
                        setState={setState}
                        allProducts={allProducts}
                    />
                )}

                {productType === 'assembled' && (
                    <AssembledProductForm
                        product={newProduct}
                        handleProductChange={handleProductChange}
                        state={state}
                        setState={setState}
                        allProducts={allProducts}
                    />
                )}

                {productType && (
                    <div className="mt-4">
                        <button
                            className={` ml-7 flex items-center justify-center rounded-xl bg-[#0260CB] px-3 py-3 text-sm font-medium text-white hover:bg-[#01499b] active:bg-[#024086]  ${
                                (!newProduct.vat ||
                                    !newProduct.name ||
                                    !newProduct.unity) &&
                                'bg-gray-500 hover:bg-gray-400 cursor-not-allowed'
                            }`}
                            disabled={
                                !newProduct.vat ||
                                !newProduct.name ||
                                !newProduct.unity
                            }
                            onClick={() => handleProductCreation(false)}
                        >
                            Créer mon produit
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default CreateProduct;
